<ng-container *transloco="let t">
  @if (attachments && attachments.length) {
    <div appearance="outline" class="max-h-[55vh] gap-0! p-0! text-sm" tuiCardLarge>
      <tui-scrollbar class="overflow-hidden!">
        <cdk-virtual-scroll-viewport
          #viewport
          class="tui-zero-scrollbar h-[55vh]"
          tuiScrollable
          [itemSize]="virtualScroll.itemSize"
          [maxBufferPx]="virtualScroll.itemSize"
          [minBufferPx]="virtualScroll.itemSize">
          <table class="w-full" tuiTable [columns]="columns">
            <thead>
              <tr tuiThGroup>
                @for (th of tableHeaders; track th.column) {
                  <th
                    *tuiHead="th.column"
                    tuiTh
                    [class]="th.classes"
                    [sorter]="th.sorter"
                    [sticky]="true"
                    [style.top.px]="-viewport['_renderedContentOffset']">
                    {{ t(th.name) }}
                  </th>
                }
              </tr>
            </thead>
            @let sortedAttachments = attachments | tuiTableSort;
            <tbody tuiTbody [data]="sortedAttachments">
              <tr
                *cdkVirtualFor="let attachment of sortedAttachments; trackBy: trackByAttachment"
                class="group bg-background-primary hover:bg-background-primary-hover"
                tuiTr>
                @for (th of tableHeaders; track th.column) {
                  <td *tuiCell="th.column" tuiTd>
                    @switch (th.column) {
                      @case ('name') {
                        <pxc-attachment-preview [attachment]="attachment" />
                      }
                      @case ('type') {
                        {{ attachment.filename | fileExtension: false | uppercase }}
                      }
                      @case ('createdBy') {
                        <pxc-user-preview [colored]="false" [user]="attachment.createdBy" />
                      }
                      @case ('createdOn') {
                        <span>
                          {{ attachment.createdOn | date: 'mediumDate' }}
                        </span>
                        <span>
                          {{ attachment.createdOn | date: 'shortTime' }}
                        </span>
                      }
                      @case ('actions') {
                        <pxc-action-buttons
                          class="flex items-center justify-evenly"
                          defaultAppearance="flat"
                          size="s"
                          [actions]="actions"
                          [entity]="attachment"
                          [iconOnly]="true" />
                      }
                    }
                  </td>
                }
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </tui-scrollbar>
    </div>
  } @else {
    <pxc-empty-state
      class="mx-auto my-3"
      data-testid="empty-state"
      icon="@tui.file"
      [title]="t('Il n\'y a aucun fichier')" />
  }
</ng-container>
